import {TextAreaField} from 'components/system/fields/TextAreaField'

type Props = {
  bookingUuid: string
  unitItemId: string
  questionId: string
}

export const Textarea = ({bookingUuid, unitItemId, questionId}: Props) => {
  return <TextAreaField name={`[${bookingUuid}][${unitItemId}][${questionId}]`} spellCheck={false} />
}
